import { SET_RESTRICTION_TEAMS } from '../actionType';

const initailState = {
  selectedTeam: [],
};

const restriction = (state = initailState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_RESTRICTION_TEAMS:
      const { restrictionTeams } = payload;
      return {
        ...state,
        selectedTeam: restrictionTeams,
      };

    default:
      return state;
  }
};

export default restriction;



// WEBPACK FOOTER //
// ./src/views/Setup/Fields/flow/reducer/restriction.js